import { CheckCircle, RefreshCw, AlertCircle } from 'lucide-react';
import React from 'react';

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getOperationColor = (operation: string): string => {
  switch (operation) {
    case 'delete':
      return 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200';
    case 'update':
      return 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200';
    case 'bulk':
      return 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200';
    default:
      return 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200';
  }
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'completed':
      return React.createElement(CheckCircle, { className: 'w-4 h-4 text-green-500' });
    case 'in_progress':
      return React.createElement(RefreshCw, { className: 'w-4 h-4 text-blue-500 animate-spin' });
    case 'failed':
      return React.createElement(AlertCircle, { className: 'w-4 h-4 text-red-500' });
    default:
      return null;
  }
};

export const downloadBackup = async (backupId: string, fileName: string) => {
  try {
    const response = await fetch(`/api/backups/${backupId}/download`);
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `backup-${fileName}.json`;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Failed to download backup:', error);
    throw error;
  }
};

export const deleteBackup = async (backupId: string) => {
  try {
    const response = await fetch(`/api/backups/${backupId}`, {
      method: 'DELETE',
    });
    return response.ok;
  } catch (error) {
    console.error('Failed to delete backup:', error);
    throw error;
  }
};
